import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const KEY = "stoof_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/50 backdrop-blur-sm p-4 pointer-events-none"
      data-testid="cookie-consent"
      role="dialog"
      aria-modal="true"
      aria-label="Cookievoorkeuren"
    >
      <div className="w-full max-w-lg bg-surface border border-border shadow-2xl pointer-events-auto">
        <div className="p-7 sm:p-9">
          <div className="flex items-center gap-3">
            <span className="grid place-items-center h-11 w-11 rounded-full bg-primary/10 text-primary">
              <Cookie size={22} />
            </span>
            <h2 className="font-display font-bold text-2xl text-text-main">Cookies op onze website</h2>
          </div>
          <p className="mt-5 text-text-muted leading-relaxed text-sm">
            Wij gebruiken cookies om onze website goed te laten werken, uw ervaring te verbeteren en
            (indien u akkoord gaat) bezoek te analyseren. Functionele cookies zijn altijd nodig; overige
            cookies plaatsen we alleen met uw toestemming. Door op "Alles accepteren" te klikken gaat u akkoord
            met het gebruik van cookies.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => choose("all")}
              data-testid="cookie-accept-all"
              className="flex-1 rounded-full bg-primary text-white font-semibold px-6 py-3.5 hover:bg-primary-light transition-colors"
            >
              Alles accepteren
            </button>
            <button
              onClick={() => choose("necessary")}
              data-testid="cookie-necessary"
              className="flex-1 rounded-full border border-text-main/20 font-semibold px-6 py-3.5 hover:border-primary hover:text-primary transition-colors"
            >
              Alleen noodzakelijk
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
